import { I18nService } from '@scorenco/core';
import { useTranslation } from 'next-i18next/pages';

import { setConfig } from './config';
import type { NextI18nConfig } from './types';

export const init = (customConfig: NextI18nConfig) => {
  setConfig(customConfig);

  I18nService.init({ useTranslation });
};
